import {PostComment, PostCommentTree} from '../_types/content';

export function buildCommentsTree(comments: PostComment[], collapsed_by_default?: boolean): PostCommentTree[] {
    const map = new Map<number, PostCommentTree>();
    const roots: PostCommentTree[] = [];

    // Create a map of comments by id
    comments.forEach(comment => {
        map.set(comment.id, {
            ...comment,
            minimiseReplies: collapsed_by_default,
            children: []
        });
    });

    // Build the tree
    comments.forEach(comment => {
        if (comment.parent === null) {
            roots.push(map.get(comment.id)!);
        } else {
            const parent = map.get(comment.parent);
            if (parent) {
                parent.children!.push(map.get(comment.id)!);
            }
        }
    });

    return roots;
}
